(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  class ProductListInfinite extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.spinner = this.querySelector('[data-infinite-spinner]');
      this.sentinel = this.querySelector('[data-infinite-sentinel]');
      this.button = this.querySelector('[data-infinite-button]');

      this.sectionId = this.dataset.sectionId;
      this.batch = parseInt(this.dataset.batch, 10) || 40;
      this.totalMax = parseInt(this.dataset.totalMax, 10) || this.batch;
      this.collectionCount = parseInt(this.dataset.collectionCount, 10) || 0;

      const firstItem = this.querySelector('.resource-list__item');
      this.container = firstItem ? firstItem.parentElement : null;
      this.loadedCount = this.container ? this.container.querySelectorAll('.resource-list__item').length : 0;

      this.currentPage = 1;
      this.loading = false;
      this.done = false;
      this.hardCap = this.collectionCount > 0 ? Math.min(this.totalMax, this.collectionCount) : this.totalMax;

      if (!this.container || !this.sentinel || this.loadedCount >= this.hardCap || this.loadedCount < this.batch) {
        this.finish();
        return;
      }

      this.handleClick = () => this.loadMore();
      if (this.button) this.button.addEventListener('click', this.handleClick);

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) { this.loadMore(); break; }
          }
        },
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.button) this.button.removeEventListener('click', this.handleClick);
    }

    async loadMore() {
      if (this.loading || this.done) return;
      this.loading = true;
      this.toggleSpinner(true);

      const nextPage = this.currentPage + 1;
      const base = window.location.pathname || '/';
      const url = base + '?section_id=' + encodeURIComponent(this.sectionId) + '&page=' + nextPage;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Request failed: ' + response.status);
        const markup = await response.text();
        const doc = new DOMParser().parseFromString(markup, 'text/html');
        const incoming = doc.querySelectorAll('.resource-list__item');

        if (incoming.length === 0) { this.finish(); return; }

        const remaining = this.hardCap - this.loadedCount;
        const slice = Array.prototype.slice.call(incoming, 0, Math.max(0, remaining));
        const html = slice.map((node) => node.outerHTML).join('');
        this.container.insertAdjacentHTML('beforeend', html);

        this.loadedCount += slice.length;
        this.currentPage = nextPage;

        if (this.loadedCount >= this.hardCap || incoming.length < this.batch) {
          this.finish();
          return;
        }

        this.loading = false;
        this.toggleSpinner(false);
        this.continueIfVisible();
      } catch (error) {
        this.loading = false;
        this.toggleSpinner(false);
        if (this.button) this.button.hidden = false;
      }
    }

    continueIfVisible() {
      if (this.done || this.loading || !this.sentinel) return;
      const rect = this.sentinel.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top <= viewport + 600) this.loadMore();
    }

    toggleSpinner(state) {
      if (this.spinner) this.spinner.hidden = !state;
    }

    finish() {
      this.done = true;
      if (this.observer) this.observer.disconnect();
      this.toggleSpinner(false);
      if (this.sentinel) this.sentinel.hidden = true;
      if (this.button) this.button.hidden = true;
    }
  }

  if (!customElements.get('product-list-infinite')) {
    customElements.define('product-list-infinite', ProductListInfinite);
  }

  } catch(e) { console.error(e); }
})();
})();
